import { render } from "./enrolmentClosed.vue?vue&type=template&id=29c843c2&scoped=true"
import script from "./enrolmentClosed.vue?vue&type=script&lang=js"
export * from "./enrolmentClosed.vue?vue&type=script&lang=js"

import "./enrolmentClosed.vue?vue&type=style&index=0&id=29c843c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c843c2"]])

export default __exports__